let previousPath: string | null = null;

export const getPreviousPath = () => previousPath;
export const setPreviousPath = (path: string) => {
  previousPath = path;
};
